import React, { ReactNode } from 'react';

import cn from '@/helpers/utils/classNames';

interface ContainerProps {
  children: ReactNode;
  className?: string;
  layoutXL?: boolean;
}

const Container = ({ children, className, layoutXL = false }: ContainerProps) => {
  return (
    <div
      className={cn('mx-auto sm:max-w-full sm:px-[15px] md:max-w-[58.75rem] lg:max-w-[67.5rem] xl:px-0', className, {
        'xl:max-w-[67.5rem]': layoutXL,
      })}
    >
      {children}
    </div>
  );
};

export default Container;
